
const state = {
	currentUser: JSON.parse(localStorage.getItem('currentUser')),
	currentInstitution: JSON.parse(localStorage.getItem('currentInstitution')),
	accessToken: localStorage.getItem('accessToken'),
	refreshToken: localStorage.getItem('refreshToken'),
}

const getters = {
    accessToken: state => state.accessToken,
	refreshToken: state => state.refreshToken,
	currentUser: state => state.currentUser,
	currentInstitution: state => state.currentInstitution
}

const actions = {

	async setTokens({ commit }, tokens) {
		await commit('saveTokens', tokens);
	},

	// sets current user
	async setCurrentUser({ commit }, currentUser) {
		commit('saveCurrentUser', currentUser);
	},

	// sets current user
	async setCurrentInstitution({ commit }, currentInstitution) {
		commit('saveCurrentInstitution', currentInstitution);
	},


	// Executed while LOGOUT
	async logoutUser({ commit }) {
		commit('removeCurrentUser');
		commit('removeToken');
		commit('removeEverything');
	}
	
}

const mutations = {

	saveCurrentUser(state, currentUser) {
		localStorage.setItem('currentUser', JSON.stringify(currentUser));
		state.currentUser = currentUser;
	},
	
	saveCurrentInstitution(state, currentInstitution) {
		localStorage.setItem('currentInstitution', JSON.stringify(currentInstitution));
		state.currentInstitution = currentInstitution;
	},

	removeCurrentUser(state) {
		localStorage.removeItem('currentUser');
		state.currentUser = null;
	},

	saveTokens(state, tokenData) {
		localStorage.setItem('accessToken', tokenData.access);
		localStorage.setItem('refreshToken', tokenData.refresh);
		state.accessToken = tokenData.access;
		state.refreshToken = tokenData.refresh;
	},

	removeToken(state) {
		localStorage.removeItem('accessToken');
		localStorage.removeItem('refreshToken');
		state.token = null;
	},

	removeEverything(state) {
		localStorage.clear();
		state.accessToken = null;
		state.refreshToken = null;
		state.token = null;
		state.currentUser = null;
		state.currentInstitution = null;
	}

}


export default { 
    state, 
    getters,
    actions,
    mutations
};

